<template>
    <div class="flex flex-col gap-2">
        <UCheckbox
            v-for="o in options"
            :key="o.value"
            :model-value="values.includes(o.value)"
            :label="o.name"
            @update:model-value="toggle(o, $event)"
        />
        <span v-if="!options.length" class="text-sm text-gray-400">Loading...</span>
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'
import { OptionNamespace } from '~/types/option'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

const client = useSupabaseClient()

const options = ref<{ name: string; value: string }[]>([])

const values = computed<string[]>(() => (Array.isArray(props.filter.value) ? props.filter.value : []))

onMounted(async () => {
    const { data } = await client.from('options')
        .select('id, label, description')
        .eq('namespace', OptionNamespace.callDecision)
        .eq('is_archived', false)
        .order('label')

    options.value = (data ?? []).map((o) => ({
        value: o.id,
        name: [o.label, o.description].filter(Boolean).join(' / '),
    }))
})

function toggle(opt: { name: string; value: string }, on: boolean) {
    const next = on ? [...values.value, opt.value] : values.value.filter(v => v !== opt.value)
    const selected = options.value.filter(o => next.includes(o.value))
    emit('update:filter', { ...props.filter, value: next.length ? next : undefined, selected: selected.length ? selected : undefined })
}
</script>
